<template>
    <div>
        <div class="table" v-for="user in users" v-if="user.courses.length > 0">
            <div class="thead">
                <h3>{{$sexyName(user.firstname, user.name)}}</h3>
                <span class="desktopOnly">Prix à l'année</span>
                <span class="desktopOnly">Réduction</span>
                <span class="desktopOnly">Prix réduit</span>
            </div>
            <div class="tbody">
                <div v-for="course in user.courses">
                    <span>{{course.name}}</span>
                    <span class="desktopOnly">{{yearPrice(course.price)}}€</span>
                    <span class="desktopOnly" v-if="isFirstCourse(course, user)">0€</span>
                    <span class="desktopOnly" v-else>45€</span>
                    <span v-if="isFirstCourse(course, user)">{{yearPrice(course.price)}}€</span>
                    <span v-else>{{yearPrice(course.price) - 45}}€</span>
                </div>
            </div>
        </div>
        <div class="tbody">
            <div>
                <span>Cotisation</span>
                <span class="desktopOnly">10€</span>
                <span class="desktopOnly">0€</span>
                <span>10€</span>
            </div>
        </div>
        <div class="thead">
            <h3>Total</h3>
            <p class="desktopOnly">{{totalYear + 10}}€</p>
            <p class="desktopOnly">{{totalDiscount + 10}}€</p>
            <h3>{{totalYear - totalDiscount + 10}}€</h3>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from "vuex";

    export default {
        name: "RichTablePayment",
        props: {
            users: Array
        },
        computed: {
            ...mapGetters({currentFamily: 'currentFamily'}),
            totalYear() {
                let total = 0
                this.users.forEach(user => {
                    user.courses.forEach(course => {
                        total += this.yearPrice(course.price)
                    })
                })

                return total
            },
            totalDiscount() {
                let coursesCount = 0
                this.users.forEach(user => {
                    coursesCount += user.courses.length
                })
                return (coursesCount - 1) * 45
            }
        },
        methods: {
            yearPrice(price) {
                return price * 3
            },
            isFirstCourse(course, user) {
                return course.id === this.users[0].courses[0].id && this.users[0].id === user.id
            }
        }
    }
</script>

<style scoped lang="scss">
    .desktopOnly {
        display: none;
    }

    .table {
        width: 100%;
    }

    .thead {
        display:flex;
        padding: 16px 12px 6px 2px;
        *:first-child{
            width: 100%;
            text-align: left;
        }
    }

    .tbody {
        border-radius: 8px;
        background: var(--color-grey-light-2);
        margin-bottom: 16px;
        >div{
            span:first-child{
                width: 100%;
                text-align: left;
            }
            padding: 8px 12px;
            display:flex;
            border-bottom: 1px solid var(--color-grey-light-1);
        }
        >div:last-child{
            border:none;
        }
    }

    @include screen-m {
        .desktopOnly {
            display: initial;
        }
        .thead{
            padding: 16px 16px 8px 2px;
            >*{
                width: 25%;
                text-align: right;
            }
            >*:first-child{
                width: 25%;
            }
        }
        .tbody{
            >div{
                padding: 12px 16px;
                >span:first-child{
                    width: 25%;
                }
                >span{
                    width: 25%;
                    text-align: right;
                }
            }
        }
    }
</style>
